import React from "react";
import { Row, Col } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

function FAQCard({ id, title, tag }) {
  /* let tagger="" */
  return (
    <LinkContainer to={`/dashboard/faq/${id}`}>
      <div className="legal-product-container ll-card-interact px-3 py-3 my-3 animated-1s fadeInUp animatedFadeInUp ">
        <Row>
          <Col className="px-3">
            <h5 className="legal-product-title">{title}</h5>
          </Col>
          <Col className="ll-faq-parent">
            {tag?.map((tagger)=>(
            <div className="lcn-category-brown px-3 py-1 my-1">{tagger}</div>
            ))}
          </Col>
        </Row>
      </div>
    </LinkContainer>
  );
}

export default FAQCard;
